import { get, getReturnError } from '../../helpers/axiosWrapper';
import { globalTtl } from '../../helpers/axiosCacheHelper';

interface IHealthRequest {
  entityType: string;
  accountReferences: Array<string>;
}

export const getHealthCheck = async (
  url: string | undefined,
  context: any,
  apiUrl: string,
  entityType: string,
  customerAccounts: Array<string>
): Promise<Common.IResult<Api.IHealthResponse>> => {
  if (!url) throw new Error('url not defined');

  let headers: IHealthRequest = {
    entityType,
    accountReferences: customerAccounts,
  };
  return await get(url + apiUrl, { headers, cache: globalTtl }, context);
};

export const getHealthCheckStatus = async (url: string | undefined, apiUrl: string, context: any): Promise<any> => {
  return await getReturnError(url + apiUrl, {}, context);
};
